import { HasFiscalPrinter } from '@pos/app/scripts/services/has-fiscal-printer';
import { PosState } from '@pos/app/scripts/services/pos-state';

/*
 * Service isFiscalReturn—returns true when on fiscal printer, and in return mode.
 * Returns true when a return transaction is loaded but NO return items are selected yet.
 * Returns false when return items are selected (negative quantities), allowing payment tab access.
 * This allows cashiers to access the payment tab once they've selected items to return.
 */
angular
  .module('posApp')
  .factory(
    'isFiscalReturn',
    (posState: PosState, hasFiscalPrinter: HasFiscalPrinter, pos) => {
      const isFiscalReturn = () => {
        if (!hasFiscalPrinter() || !posState.returnTransaction) {
          return false;
        }

        // Check if there are actual return items (negative quantities) in the transaction
        // If return items exist, return false to ENABLE the payment tab (cashier needs to process refund)
        if (pos && pos.transaction && pos.transaction.receipt) {
          const hasReturnItems = pos.transaction.receipt.some(
            (line) => line && line.category === 'barcode' && line.qty < 0,
          );

          // Return false if there are return items (enables payment tab for refund processing)
          // Return true only if no return items are selected yet (disables payment tab)
          return !hasReturnItems;
        }

        // If transaction is not yet initialized, return true to disable payment tab
        // (waiting for return items to be selected)
        return true;
      };

      return isFiscalReturn;
    },
  );
